import { render, staticRenderFns } from "./Dialog-Menu.vue?vue&type=template&id=0881d739&"
import script from "./Dialog-Menu.vue?vue&type=script&lang=js&"
export * from "./Dialog-Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports